export default __webpack_public_path__ + "media/images/metal_detect/foxes_detect_4-c75957bfa91a53ec30939310ba2b84ce.svg";